import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-22007476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Manage Courses")
], -1))
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "h-1/2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "bg-primary flex justify-center items-center p-1 rounded-t"
}
const _hoisted_9 = { class: "card-body p-4 h-1/2" }
const _hoisted_10 = { class: "text-sm overflow mt-2 text-justify text-black" }
const _hoisted_11 = {
  key: 1,
  class: "mt-8 text-sm text-center text-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.allCourses.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCourses, (singlecourse, scIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: singlecourse.id,
                class: "mt-2"
              }, [
                _createElementVNode("div", {
                  class: "card cursor-pointer rounded",
                  onClick: ($event: any) => (_ctx.onLoad(singlecourse, scIndex))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("figure", null, [
                      (singlecourse.courseImage)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: singlecourse.courseImage,
                            class: "bg-cover bg-no-repeat bg-center rounded-t"
                          }, null, 8, _hoisted_7))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("h1", {
                              class: _normalizeClass(["text-white text-lg", singlecourse.courseName.length > 40? 'table-ellipsis':''])
                            }, _toDisplayString(singlecourse.courseName), 3)
                          ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h1", {
                      class: _normalizeClass(singlecourse.courseName.length > 40? 'table-ellipsis':'')
                    }, _toDisplayString(singlecourse.courseName), 3),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(singlecourse.courseDescription), 1)
                  ])
                ], 8, _hoisted_5)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, "No courses assigned to users"))
    ])
  ]))
}